/**
 * inputNumberDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

export function inputNumberDirective() {
    return {
        // language=HTML
        template: `
            <md-input-container>
                <label>{{ label }}</label>

                <input type="number"
                       ng-attr-id="{{ id || inputId }}"
                       name="{{ name || '' }}"
                       ng-model="value"
                       ng-change="_onChange()"
                       ng-disabled="disabled"
                       ng-required="required"
                       min="{{ min }}"
                       max="{{ max }}"
                       step="{{ step }}">

                <div class="hint" ng-if="hint">
                    {{ hint }}
                </div>

                <div ng-if="form && name" ng-messages="form[name].$error">
                    <div ng-message="required">Required</div>
                    <div ng-message="min">Value should be no less than {{ min }}</div>
                    <div ng-message="max">Value should be no more than {{ max }}</div>
                    <div ng-message="custom">{{ form[name].customError }}</div>
                    <div ng-repeat="(key, message) in errorMessages" ng-message="{{ key }}">{{ message }}</div>
                </div>
            </md-input-container>
        `,
        scope: {
            disabled: '=ngDisabled',
            errorMessages: '=errorMessages',
            form: '=form',
            id: '@?id',
            inputId: '@?inputId',
            label: '@label',
            max: '=?max',
            min: '=?min',
            name: '@name',
            onChange: '&?change',
            placeholder: '@?placeholder',
            required: '=?required',
            step: '=?step',
            hint: '@?hint',
            value: '=value',
        },
        link: function(scope, element, attrs) {
            element.addClass('app-form-field');

            const $inputContainer = element.find('md-input-container');
            const $input = $inputContainer.find('input')[0];

            scope._onChange = _onChange;

            // If it's undefined on the scope, it may mean that the attribute is there but
            // without content. If the attribute isn't undefined then we know it's been added.
            if (scope.required === undefined && attrs.required !== undefined) {
                scope.required = true;
            }

            scope.$watch('placeholder', placeholder => {
                if (placeholder) {
                    $input.placeholder = placeholder;
                    $inputContainer.addClass('md-input-has-placeholder');
                } else {
                    $input.placeholder = '';
                    $inputContainer.removeClass('md-input-has-placeholder');
                }
            });

            function _onChange() {
                if (angular.isFunction(scope.onChange)) {
                    scope.onChange();
                }

                if (!scope.form || !scope.name) {
                    return;
                }

                if (scope.value) {
                    scope.form[scope.name].$setValidity('custom', true);
                    scope.form[scope.name].customError = null;
                }
            }
        },
    };
}
